import { render } from "./UserTakeOverRolesForm.vue?vue&type=template&id=e9ab8916&ts=true"
import script from "./UserTakeOverRolesForm.vue?vue&type=script&lang=ts"
export * from "./UserTakeOverRolesForm.vue?vue&type=script&lang=ts"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__